import { getCampaignByAgeQuery, getCampaignByGenderQuery, getCampaignByClassificationQuery, getCampaignPaymentsByDateQuery, getCampaignPaymentsByValueQuery, getCampaignDataQuery } from '@/graphl/queries/dashboard'
import { formatPrice, formatDateDayMonth, formatPriceSlim } from '@/helpers'

const state = {
  listDataAge: [],
  listDataGender: [],
  listDataClassification: [],
  listPaymentsByDate: [],
  listCoutPaymentsByDate: [],
  listAmoutPaymentsByDate: [],
  listDatePaymentsByDate: [],
  listPaymentsByValue: [],
  listCoutPaymentsByValue: [],
  listAmoutPaymentsByValue: [],
  listTotalPaymentsByValue: [],
  listCampaignData: [],
  loading: false
}

const mutations = {
  'TOGGLE_LOADING_DATA' (state, payload = false) {
    state.loading = !!payload
  },
  'SET_LIST_DATA_AGE' (state, payload) {
    state.listDataAge = payload
  },
  'SET_LIST_DATA_GENDER' (state, payload) {
    state.listDataGender = payload
  },
  'SET_LIST_DATA_CLASSIFICATION' (state, payload) {
    state.listDataClassification = payload
  },
  'SET_LIST_PAYMENTS_BY_DATE' (state, payload) {
    state.listPaymentsByDate = payload
  },
  'SET_LIST_COUNT_PAYMENTS_BY_DATE' (state, payload) {
    state.listCoutPaymentsByDate = payload
  },
  'SET_LIST_AMOUT_PAYMENTS_BY_DATE' (state, payload) {
    state.listAmoutPaymentsByDate = payload
  },
  'SET_LIST_DATE_PAYMENTS_BY_DATE' (state, payload) {
    state.listDatePaymentsByDate = payload
  },
  'SET_LIST_PAYMENTS_BY_VALUE' (state, payload) {
    state.listPaymentsByValue = payload
  },
  'SET_LIST_COUNT_PAYMENTS_BY_VALUE' (state, payload) {
    state.listCoutPaymentsByValue = payload
  },
  'SET_LIST_AMOUT_PAYMENTS_BY_VALUE' (state, payload) {
    state.listAmoutPaymentsByValue = payload
  },
  'SET_LIST_TOTAL_PAYMENTS_BY_VALUE' (state, payload) {
    state.listTotalPaymentsByValue = payload
  },
  'SET_LIST_CAMPAIGN_DATA' (state, payload) {
    state.listCampaignData = payload
  }
}

const actions = {
  getCampaignByAgeQuery ({commit}, id ) {
    commit('TOGGLE_LOADING_DATA', true)
    getCampaignByAgeQuery (id)
      .then( res => {
        const { campaignByAge } = res.data
        this.campaignAge = campaignByAge.map((data) => ({
          label: data.label,
          createdCount: data.createdCount,
          convertedCount: data.convertedCount,
          percentConvertedCreated: data.percentConvertedCreated,
          chargedAmount: `R$ ${formatPrice(data.chargedAmount)}`,
          convertedPaymentAmount: `R$ ${formatPrice(data.convertedPaymentAmount)}`,
          convertedToPaymentPercent: data.convertedToPaymentPercent,
          campaignGoal: data.campaignGoal,
          averageTicketPaidValue: `R$ ${formatPrice(data.averageTicketPaidValue)}`,
          totalAmountPaid: `R$ ${formatPrice(data.totalAmountPaid)}`,
        }))
        commit('SET_LIST_DATA_AGE', this.campaignAge)
        commit('TOGGLE_LOADING_DATA', false)
      }).catch(e => {
        this.erros = e
        commit('TOGGLE_LOADING_DATA', false)
      })
  },

  getCampaignByGenderQuery ({commit}, id ) {
    commit('TOGGLE_LOADING_DATA', true)
    getCampaignByGenderQuery (id)
      .then( res => {
        const { campaignByGender } = res.data
        this.campaignGender = campaignByGender.map((data) => ({
          label: data.label,
          createdCount: data.createdCount,
          convertedCount: data.convertedCount,
          percentConvertedCreated: data.percentConvertedCreated,
          chargedAmount: `R$ ${formatPrice(data.chargedAmount)}`,
          convertedPaymentAmount: `R$ ${formatPrice(data.convertedPaymentAmount)}`,
          convertedToPaymentPercent: data.convertedToPaymentPercent,
          campaignGoal: data.campaignGoal,
          averageTicketPaidValue: `R$ ${formatPrice(data.averageTicketPaidValue)}`,
          totalAmountPaid: `R$ ${formatPrice(data.totalAmountPaid)}`,
        }))
        commit('SET_LIST_DATA_GENDER', this.campaignGender)
        commit('TOGGLE_LOADING_DATA', false)
      }).catch(e => {
        this.erros = e
        commit('TOGGLE_LOADING_DATA', false)
      })
  },

  getCampaignByClassificationQuery ({commit}, id ) {
    commit('TOGGLE_LOADING_DATA', true)
    getCampaignByClassificationQuery (id)
      .then( res => {
        const { campaignByClassification } = res.data
        this.campaignClassification = campaignByClassification.map((data) => ({
          label: data.label,
          createdCount: data.createdCount,
          convertedCount: data.convertedCount,
          percentConvertedCreated: data.percentConvertedCreated,
          chargedAmount: `R$ ${formatPrice(data.chargedAmount)}`,
          convertedPaymentAmount: `R$ ${formatPrice(data.convertedPaymentAmount)}`,
          convertedToPaymentPercent: data.convertedToPaymentPercent,
          campaignGoal: data.campaignGoal,
          averageTicketPaidValue: `R$ ${formatPrice(data.averageTicketPaidValue)}`,
          totalAmountPaid: `R$ ${formatPrice(data.totalAmountPaid)}`,
        }))
        commit('SET_LIST_DATA_CLASSIFICATION', this.campaignClassification)
        commit('TOGGLE_LOADING_DATA', false)
      }).catch(e => {
        this.erros = e
        commit('TOGGLE_LOADING_DATA', false)
      })
  },

  getCampaignPaymentsByDateQuery ({commit}, id ) {
    commit('TOGGLE_LOADING_DATA', true)
    getCampaignPaymentsByDateQuery (id)
      .then( res => {
        const { campaignPaymentsByDate } = res.data
        this.paymentsByDate = campaignPaymentsByDate.map((data) => ({
          count: data.count.toLocaleString('pt-BR'),
          amount: data.amount.toFixed(2),
          date: formatDateDayMonth(data.date),
        }))
        commit('SET_LIST_PAYMENTS_BY_DATE', this.paymentsByDate)

        const listCount = this.paymentsByDate.map(data => data.count)
        commit('SET_LIST_COUNT_PAYMENTS_BY_DATE', listCount)

        const listAmout = this.paymentsByDate.map(data => data.amount)
        commit('SET_LIST_AMOUT_PAYMENTS_BY_DATE', listAmout)

        const listDate = this.paymentsByDate.map(data => data.date)
        commit('SET_LIST_DATE_PAYMENTS_BY_DATE', listDate)

        commit('TOGGLE_LOADING_DATA', false)
      }).catch(e => {
        this.erros = e
        commit('TOGGLE_LOADING_DATA', false)
      })
  },

  getCampaignPaymentsByValueQuery ({commit}, id ) {
    commit('TOGGLE_LOADING_DATA', true)
    getCampaignPaymentsByValueQuery (id)
      .then( res => {

        const { campaignPaymentsByValue } = res.data
        this.paymentsByValue = campaignPaymentsByValue.map((data) => ({
          count: data.count.toLocaleString('pt-BR'),
          amount: formatPriceSlim(data.amount),
          total: `R$ ${formatPrice(data.total)}`,
        }))

        commit('SET_LIST_PAYMENTS_BY_VALUE', this.paymentsByValue)

        const listCount = this.paymentsByValue.map(data => data.count)
        commit('SET_LIST_COUNT_PAYMENTS_BY_VALUE', listCount)

        const listAmout = this.paymentsByValue.map(data => data.amount)
        commit('SET_LIST_AMOUT_PAYMENTS_BY_VALUE', listAmout)

        const listTotal = this.paymentsByValue.map(data => data.total)
        commit('SET_LIST_TOTAL_PAYMENTS_BY_VALUE', listTotal)

        commit('TOGGLE_LOADING_DATA', false)
      }).catch(e => {
        this.erros = e
        commit('TOGGLE_LOADING_DATA', false)
      })
  },

  getCampaignDataQuery ({commit}, id ) {
    commit('TOGGLE_LOADING_DATA', true)
    getCampaignDataQuery (id)
      .then( res => {
        const { campaign } = res.data
        campaign.dueDate = formatDateDayMonth(campaign.dueDate)
        campaign.value = `R$ ${formatPrice(campaign.value)}`
        campaign.peopleRegisteredCount = campaign.peopleRegisteredCount.toLocaleString('pt-BR')
        campaign.registeredAmount = `R$ ${formatPrice(campaign.registeredAmount)}`
        campaign.peopleRegisteredOrPaidCount = campaign.peopleRegisteredOrPaidCount.toLocaleString('pt-BR')
        campaign.paidAmount = `R$ ${formatPrice(campaign.paidAmount)}`
        campaign.paidAmountPercentage = `${campaign.paidAmountPercentage}%`
        campaign.peoplePaidCount = campaign.peoplePaidCount.toLocaleString('pt-BR')
        campaign.paidCountPercentage = `${campaign.paidCountPercentage}%`
        campaign.goalValue = `R$ ${formatPrice(campaign.goalValue)}`
        campaign.goalValuePercent = `${campaign.goalValuePercent}%`
        campaign.averageAmount = `R$ ${formatPrice(campaign.averageAmount)}`
        commit('SET_LIST_CAMPAIGN_DATA', campaign)
        commit('TOGGLE_LOADING_DATA', false)
      }).catch(e => {
        this.erros = e
        commit('TOGGLE_LOADING_DATA', false)
      })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
